<template lang="html">

  <div class="tarifas-view margin-menu -luz">

    <header class="encabezado-seccion row-start">
      <div class="container row-between">
        <h1>
          <span class="big">{{ $t('tarifasLuz.hero.title1') }} {{ $t('luz') }}</span>
          <span class="small">{{ $t('tarifasLuz.hero.title2') }}</span>
        </h1>
      </div>
    </header>


    <div class="intro-tarifa">

      <nav class="breadcrumb container row-start">
        <a>{{ $t('inicio') }}</a>
        <a>{{ $t('luz') }}</a>
        <a>{{ $t('tarifasLuz.hero.title2') }}</a>
      </nav>


      <div class="contenedor-intro-tarifa container row-start ais">
        <div class="contenedor-texto column-start" v-if="!!precios">
          <h3 class="-orange">{{ $t('tarifasLuz.intro.title') }}</h3>
          <p class="description" v-html="$t('tarifasLuz.intro.description', { cuota: $options.filters.comma(precios.cuotaluz) })"></p>
        </div>

        <div class="contenedor-imagen row-center" data="helado">
          <div class="contenedor-titulo row-center">
            <h2 v-html="$t('tarifasLuz.intro.tituloImagen')"></h2>
          </div>
        </div>
        <img src="/static/img/confeti-dark.gif" class="confeti">
      </div>

    </div>


    <div class="selector-vivienda grid-3">
      <h2 class="separate column-center">
        <b>{{ $t('tarifasLuz.selector.title') }}</b>
        <b>{{ $t('tarifasLuz.selector.subtitle') }}</b>
      </h2>
      <nav class="selector-list row-between ais ">
        <template v-for="(item, key) in $t('tarifasLuz.selector.items.hogar')">
          <a class="selector menos" :class="key" @click="() => { activo = key; tarifaActiva = null; } " :activo="activo == key">
            <strong>{{ item.title }}</strong>
            <span v-html="item.description"></span>
          </a>
        </template>
      </nav>

      <div class="texto-intro-movil">
        <h4 v-if="activo == 'menos'">Esta es la potencia que tienen la mayoría de las viviendas. Así que seguramente
          estas tarifas sean para ti.</h4>
        <h4 v-if="activo == 'mas'">Si tu casa, piso, chalet es excepcional, ya sea por su gran tamaño o alguna otra
          cualidad que la hace poco corriente. Estas serán tus tarifas.</h4>
      </div>

    </div>

    <botonera-tarifas v-if="activo !== 'solar'" :suministro="'luz'" :tarifas="$t(`tarifasLuz.tarifas.hogar.${activo}`)"
      :tarifaActiva="tarifaActiva" @activarTarifa="tarifaActiva = $event"></botonera-tarifas>

    <tarifas-estandar v-if="activo == 'estandar'" :tarifaActiva="tarifaActiva"></tarifas-estandar>
    <tarifas-solar v-if="activo == 'solar'"></tarifas-solar>
    <tarifas-coche-electrico v-if="activo == 'coche_electrico'" :tarifaActiva="tarifaActiva"></tarifas-coche-electrico>
    <banner-mantenimiento></banner-mantenimiento>
    <banner-somos-ahorro></banner-somos-ahorro>
  </div>

</template>

<script lang="js">

import tarifasEstandar from '@/components/views/luz/tarifas-estandar';
import tarifasSolar from '@/components/views/luz/tarifas-solar';
import tarifasCocheElectrico from '@/components/views/luz/tarifas-coche';

import bannerSomosAhorro from '@/components/parts/banner-somos-ahorro';
import bannerMantenimiento from '@/components/parts/banner-mantenimiento';

import botoneraTarifas from '@/components/parts/botonera-tarifas.vue';


import { mapActions, mapGetters } from 'vuex';


export default {
  name: 'tarifas',
  mounted() {
    this.checkResponsive()
    window.addEventListener('resize', this.checkResponsive)
    this.requestIsEmpresa(false)

    if (!!this.$route.params.type) {
      this.activo = this.$route.params.type;

      setTimeout(e => {
        $("html,body").animate({ scrollTop: $(".contenedor-tarifas").position().top - 100 })
      }, 200)

    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkResponsive)
  },
  data() {
    return {
      activo: 'estandar',
      tarifaActiva: null,
      isMobile: false
    }
  },
  components: {
    'tarifas-estandar': tarifasEstandar,
    'tarifas-solar': tarifasSolar,
    'tarifas-coche-electrico': tarifasCocheElectrico,
    'banner-mantenimiento': bannerMantenimiento,
    'banner-somos-ahorro': bannerSomosAhorro,
    'botonera-tarifas': botoneraTarifas
  },
  computed: {
    ...mapGetters({
      precios: 'getPrecios'
    })
  },
  methods: {
    ...mapActions(['requestIsEmpresa']),
    checkResponsive() {
      this.isMobile = window.innerWidth <= 768
    }
  },
  watch: {
    'activo'() {
      if (!this.isMobile) {
        $("html,body").animate({
          scrollTop: $(".contenedor-tarifas").position().top - 150
        })
      } else{
        $("html,body").animate({
          scrollTop: $(".coche_electrico").position().top
        })
      }
   }
  }
}
</script>

<style scoped lang="scss">
.btn.-degree {
  margin-bottom: 80px;
  margin-top: -20px;
}

.encabezado-seccion {
  margin-bottom: 0;
}

h2.separate b:last-of-type {
  text-transform: inherit;
}

@media screen and (max-width:930px) {
  h2.separate b:last-of-type {
    font-size: 60px;
  }

  .nombre-tarifas h3 {
    font-size: 32px;

    span {
      font-size: 20px;
    }
  }
}

@media screen and (max-width:730px) {
  h2.separate b:last-of-type {
    font-size: 50px;
  }

  .nombre-tarifas {

    display: none;
  }


}
</style>



// WEBPACK FOOTER //
// src/components/views/tarifas-luz.vue